import { assertRequestCurrent, assertQuoteAffordable, decimalUnits } from './generation-request.js';

// The injectable boundary lets cancellation/account-change behavior be tested
// without spending credits or opening a browser checkout.
export async function confirmQuotedRequest({ request, quote, context, review, refreshContext, requote }) {
  assertRequestCurrent(request, context);
  assertQuoteAffordable(quote, context.balance);
  if (decimalUnits(quote.total) === 0n) {
    // Settings and entitlement can change while model inputs/prices are loading.
    // Covered work skips the modal, but still validates the account before create.
    const fresh = await refreshContext();
    assertRequestCurrent(request, fresh);
    assertQuoteAffordable(quote, fresh.balance);
    return quote;
  }

  await review({ request, quote, balance: context.balance,
    discountBps: context.subscription?.frontierDiscountBps || 0 });
  const fresh = await refreshContext();
  assertRequestCurrent(request, fresh);
  const currentQuote = await requote();
  const afterQuote = await refreshContext();
  assertRequestCurrent(request, afterQuote);
  assertQuoteAffordable(currentQuote, afterQuote.balance);
  if (currentQuote.total !== quote.total || currentQuote.premiumTotal !== quote.premiumTotal ||
      JSON.stringify(currentQuote.slotIds) !== JSON.stringify(quote.slotIds)) {
    const error = new Error('The price changed. Review the updated quote before generating.');
    error.code = 'QUOTE_CHANGED';
    error.request = request;
    error.quote = currentQuote;
    throw error;
  }
  return currentQuote;
}
